<template>
  <div class="customer-single-report">
    <!-- 统计信息 -->
    <div class="statistics">
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">客户名称</p>
          <p class="statistics-item-content">{{ customerName }}</p>
          <div class="statistics-item-proportion">
            <!-- <span class="statistics-item-proportion-title">本月以来总占比</span>
            <span class="statistics-item-proportion-val">10.8%</span> -->
          </div>
        </div>
        <img class="statistics-item-img" src="../../../../assets/images/operate/customer.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">出库单量</p>
          <p class="statistics-item-content">{{ outboundNum }}</p>
          <div class="statistics-item-proportion">
            <!-- <span class="statistics-item-proportion-title">自上月以来</span>
            <img class="lifting" src="../../../../assets/images/operate/rise.png">
            <img class="lifting" src="../../../../assets/images/operate/decline.png">
            <span class="statistics-item-proportion-val">10.8%</span> -->
          </div>
        </div>
        <img class="statistics-item-img" src="../../../../assets/images/operate/out-bound.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">收入金额</p>
          <p class="statistics-item-content">{{ totalAmount }}</p>
          <div class="statistics-item-proportion">
            <span class="statistics-item-proportion-title">保底差额</span>
            <span class="statistics-item-proportion-val statistics-item-proportion-difference">{{ difference }}</span>
          </div>
        </div>
        <img class="statistics-item-img" src="../../../../assets/images/operate/total-amount.png">
      </div>
      <div class="statistics-item">
        <div>
          <p class="statistics-item-title">成本金额</p>
          <p class="statistics-item-content">{{ totalCost }}</p>
          <div class="statistics-item-proportion">
            <!-- <span class="statistics-item-proportion-title">自上月以来</span>
            <img class="lifting" src="../../../../assets/images/operate/rise.png">
            <img class="lifting" src="../../../../assets/images/operate/decline.png">
            <span class="statistics-item-proportion-val">10.8%</span> -->
          </div>
        </div>
        <img class="statistics-item-img" src="../../../../assets/images/operate/cost-amount.png">
      </div>
    </div>

    <!-- 客户单报列表 -->
    <div class="table">
      <el-table :data="tableData" style="width: 100%" :header-cell-class-name="headerCellClassName">
        <el-table-column
        class="ss"
        v-for="(item, index) in tableTitleList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :min-width="item.width">
          <template slot-scope="scope">
            <div
              :class="[
                scope.row[item.prop] < 0 ? 'hign-red':'', 
                item.alignment === 'right'?'right-align-width':''
              ]"
            >{{scope.row[item.prop]}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { numsToRMBSymbolAndMillimeter } from "common/js/util";
import { getDBUserRealName } from "common/js/storage";
import Operate from "models/operate.js";
export default {
  data() {
    return {
      username: '',
      projectId: '',
      date: '',
      /* 1、账单中的费用类型都属于第一项 2、其他成本 */
      dataType: '',
      customerName: '',
      // 出库单量
      outboundNum: '',
      totalAmount: '',
      // 保底差额
      difference: '',
      // 成本金额
      totalCost: '',
      tableData: [],
      tableTitleList: [
        {prop: 'feeType', label: '费用类型', width: '', alignment:'left'},
        {prop: 'date', label: '日期', width: '', alignment:'left'},
        {prop: 'detailName', label: '费用明细', width: '', alignment:'left'},
        {prop: 'value', label: '数量', width: '', alignment:'left'},
        {prop: 'taxIncludedAmount', label: '收入金额', width: '', alignment:'right'},
        {prop: 'cost', label: '成本金额', width: '', alignment:'right'},
        {prop: 'grossProfit', label: '总毛利', width: '', alignment:'right'},
        {prop: 'unitGrossProfit', label: '单位毛利', width: '', alignment:'right'},
        // {prop: 'unWeighedNum', label: '未称重单量', width: '', alignment:'left'},
      ],
    };
  },
  created() {
    this.projectId = this.$route.query.id
    this.date = this.$route.query.date
    this.username = getDBUserRealName();
    this.getTableData()
  },
  
  methods: {
    /**
     * @desc 获取客户单报
     */
    getTableData() {
      let date = this.date
      let projectId = this.projectId
      Operate
        .getCustomerSingleReport(projectId, date)
        .then(res => {
          if (res.success) {
            let { customerName, outboundNum, totalAmount, totalCost, feeDetailList, difference, otherCostDetailList} = res.result
            this.customerName = customerName
            this.outboundNum = numsToRMBSymbolAndMillimeter(outboundNum)
            this.totalAmount = numsToRMBSymbolAndMillimeter(totalAmount)
            this.difference = numsToRMBSymbolAndMillimeter(difference)
            this.totalCost = numsToRMBSymbolAndMillimeter(totalCost)
      
            let feeDetailArr = this.handleCommonList(feeDetailList)
            let otherCostDetailArr = this.handleCommonList(otherCostDetailList)
            this.tableData = [...feeDetailArr, ...otherCostDetailArr];
          } else {
            this.$message.error(res.message);
          }
        });
    },

    handleCommonList(list) {
      let arr = []
      list.map(i => {
        let obj = {}
        obj.cost = numsToRMBSymbolAndMillimeter(i.cost)
        obj.costHistoryFlag = i.costHistoryFlag
        obj.dataType = i.dataType
        obj.date = this.date
        obj.detailName = i.detailName
        obj.feeType = i.feeType
        obj.grossProfit = numsToRMBSymbolAndMillimeter(i.grossProfit)
        obj.id = i.id
        obj.incomeHistoryFlag = i.incomeHistoryFlag
        obj.taxIncludedAmount = numsToRMBSymbolAndMillimeter(i.taxIncludedAmount)
        obj.unWeighedNum = i.unWeighedNum
        obj.unitGrossProfit = numsToRMBSymbolAndMillimeter(i.unitGrossProfit)
        obj.value = i.value
        arr.push(obj)
      })
      return arr
    },
    
    /**
     * @desc 表头添加类名处理数字右对齐
     */
    headerCellClassName({ columnIndex }) {
      if (columnIndex > 3 && columnIndex < 8) {
        return 'right-align'
      }
    },
  }
};
</script>
<style lang="scss">
.customer-single-report {
  flex: 1;
  display: flex;
  flex-direction: column;
  .statistics {
    width: 100%;
    height: 132px;
    @include flex-between;
    margin-bottom: 16px;
    &-item {
      width: 25%;
      height: 100%;
      border-radius: 4px;
      background: white;
      margin-right: 20px;
      @include flex-between;
      box-sizing: border-box;
      padding: 0px 30px 0px 19px;
      border: 1px solid $baseFourSnow;
      &-img {
        width: 48px;
        height: 48px;
      }
      &-title {
        font-size: 12px;
        font-family: 'PingFang SC-Regular, PingFang SC';
        font-weight: 400;
        color: $baseTwoGrey;
        margin-bottom: 10px;
      }
      &-content {
        height: 20px;
        font-size: 20px;
        font-family: 'PingFang SC-Heavy, PingFang SC';
        font-weight: 800;
        color: $baseGrey;
        margin-bottom: 10px;
      }
      &-proportion {
        height: 14px;
        font-size: 12px;
        &-title {
          color: $baseThreeGrey;
          margin-right: 4px;
        }
        &-difference {
          color: $baseBlue;
        }
        .lifting {
          width: 12px;
          height: 12px;
          margin-right: 4px;
        }
      }
    }
    &-item:first-child {
      background: $baseBlue;
      color: white;
      .statistics-item-title,
      .statistics-item-content {
        color: white;
      }
      .statistics-item-proportion {
        &-title,
        &-val {
          color: $operator;
        }
      }
    }
    &-item:last-child {
      margin-right: 0px;
    }
  }
  .table {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    padding: 20px 24px;
    .hign-red {
      color: #FF0909;
    }
    .right-align-width {
      width: 110px;
      text-align: right;
    }
  }
  .table .el-table .el-table__header-wrapper .el-table__header tr th.right-align {
    .cell {
      width: 142px;
      text-align: right;
    }
  }
}
</style>